import React from 'react';
import { Redirect } from 'react-router-dom';

function index() {
  return <Redirect to="/boards" />;
}

export default index;
